<template>
    <transition name="fade">
        <a :href="notificationData && notificationData.success ? notificationData.link : 'javascript:;'" 
           class="row global-vue-notification cart-notification" 
           :class="{ 'cart-error-notification' : notificationData && !notificationData.success, 'success-anim' : notificationData && notificationData.success }" 
           :id="id"
           >
            <div class="row mx-0 notification-content">
                <i v-if="!notificationData && notificationData.success" class="notification-msg-icon error ecom-error" />
                <div class="ws-response-text" :class="{ 'col': notificationData && notificationData.success, 'col-auto': notificationData && !notificationData.success }" :id="messageId">
                    {{ notificationData.message }}
                </div>
                <div v-if="notificationData && !notificationData.success" class="col p-0 text-right" @click="$emit('fademe', null, true)">
                    <i class="notification-msg-icon close-popup ecom-close"/>
                </div>
            </div>
        </a>
    </transition>
</template>

<script>
    export default {
        name: 'CartNotification',
        components: {},
        props: {
            // html identifiers
            id: {
                type: String,
                default: 'wsResponseCart',
            },
            /*showNotification: {
                type: Boolean,
                default: false,
            },*/
            messageId: {
                type: String,
                default: 'wsResponseCartText',
            },
            // data default
            notificationData: {
                link: {
                    type: String,
                    default: '',
                },
                message: {
                    type: String,
                    default: '',
                },
                actionText: {
                    type: String,
                    default: 'View cart', // __('kVIEW_CART', 'View cart')
                },
                success: {
                    type: Boolean,
                    default: false,
                },
            },
        },
        data: function() {
            return {
                //showNotification: false
            };
        },
        computed: {},
        methods: {},
        watch: {},
        mounted() {}
    };
</script>

<style lang="scss" scoped>

</style>